const carDealerID = 22;

export default carDealerID;
